import {Grid, Typography, Box} from '@mui/material'
import {Link as MUILink} from '@mui/material'
import {Link} from "react-router-dom";

export default function Footer() {
    return(
        <Box
            component="footer"
            mt={'auto'}
            bgcolor={'primary.dark'}
            py={1}
        >
            <Box
                display={{xs:'none', md:'flex'}}
                flexGrow={1}
                fontWeight={'light'}
            >
                <DesktopFooter />
            </Box>
            <Box
                display={{xs:'flex', md:'none'}}
                flexGrow={1}
                fontWeight={'light'}
            >
                <MobileFooter />
            </Box>
        </Box>
    )
}

function DesktopFooter() {
    let d = new Date()
    let year = d.getFullYear()
    return(
        <Grid
            container
            direction={'row'}
            justifyContent={'center'}
            alignItems={'flex-end'}
        >
            <Grid item>
                <Typography
                    sx={{letterSpacing:'.1rem', mr:1.5, ml: 1.5}}
                    color={'white'}
                    variant={'subtitle1'}
                > © {year} &nbsp; The University of Vermont </Typography>
            </Grid>
            <Grid item>
                <MUILink
                    underline={'none'}
                    href={'https://www.uvm.edu/compliance/website-privacy-policy/terms-use'}
                >
                    <Typography
                        sx={{
                            letterSpacing: '.1rem',
                            "&:hover": {color:'secondary.main'},
                            mr: 2, ml:2
                        }}
                        color={'white'}
                        variant={'subtitle1'}
                    > Terms of Use </Typography>
                </MUILink>
            </Grid>
            <Grid item>
                <MUILink
                    underline='none'
                    href={'https://www.uvm.edu/aaeo/americans-disabilities-act-ada-and-reasonable-accommodations'}
                >
                    <Typography
                        sx={{
                            letterSpacing: '.1rem',
                            "&:hover": {color:'secondary.main'},
                            mr: 2, ml:2
                        }}
                        color={'white'}
                        variant={'subtitle1'}
                    > Accessibility </Typography>
                </MUILink>
            </Grid>
            <Grid item>
                <MUILink
                    underline='none'
                    href={'https://www.linkedin.com/in/arimenezes/'}
                >
                    <Typography
                        sx={{
                            letterSpacing: '.1rem',
                            "&:hover": {color:'secondary.main'},
                            mr: 2, ml:2
                        }}
                        color={'white'}
                        variant={'subtitle1'}
                    > Created By </Typography>
                </MUILink>
            </Grid>
        </Grid>
    )
}

function MobileFooter() {
    let d = new Date()
    let year = d.getFullYear()
    return(
        <Grid
            container
            direction={'row'}
            justifyContent={'center'}
            alignItems={'center'}
        >
            <Grid item>
                <Typography
                    sx={{ mr:.75, ml: .75}}
                    color={'white'}
                    variant={'subtitle2'}
                > © {year} </Typography>
            </Grid>
            <Grid item>
                <MUILink
                    underline={'none'}
                    href={'https://www.uvm.edu/compliance/website-privacy-policy/terms-use'}
                >
                    <Typography
                        sx={{
                            "&:hover": {color:'secondary.main'},
                            mr: .75, ml:.75
                        }}
                        color={'white'}
                        variant={'subtitle2'}
                    > Terms of Use </Typography>
                </MUILink>
            </Grid>
            <Grid item>
                <Link to={"/contactus"} style={{textDecoration:'none'}}>
                <Typography
                    sx={{
                        "&:hover": {color:'secondary.main'},
                        mr: .75, ml:.75
                    }}
                    color={'white'}
                    variant={'subtitle2'}
                > Contact Us
                </Typography>
            </Link>
            </Grid>
        </Grid>
    )

}
